/** @jsxImportSource theme-ui */
import { darken } from '@theme-ui/color'
import { Box } from 'theme-ui'
import React, { createContext, useContext, useState } from 'react'
import { scaleDown as Menu } from 'react-burger-menu'
import {
  FaArchive,
  FaHome,
  FaPlusCircle,
  FaQuestionCircle,
  FaSignInAlt,
  FaSignOutAlt,
} from 'react-icons/fa'
import { GiHamburgerMenu } from 'react-icons/gi'
import { useNavigate } from 'react-router-dom'
import useCurrentUserStore, {
  getUserToken,
  removeUserToken,
} from '../../stores/currentUser'
import colors from '../../theme/colors'
import { notifySuccess } from '../Notif'
import { sidebarStyles } from './SidebarMenu'

const SidebarMenuContext = createContext(null)

export default function LandingPageSidebarMenu() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <SidebarMenuContext.Provider
      value={{
        isOpen,
        toggle: () => setIsOpen(!isOpen),
        onStateChange: (state) => setIsOpen(state.isOpen),
      }}
    >
      <Navigation />
    </SidebarMenuContext.Provider>
  )
}

function Navigation(props: any) {
  const userToken = getUserToken()
  const { removeCurrentUser } = useCurrentUserStore()
  const { isOpen, toggle, onStateChange } = useContext(SidebarMenuContext)
  const navigate = useNavigate()

  function logout() {
    removeUserToken()
    removeCurrentUser()
    notifySuccess('Logout successfull')
  }

  const closeAndNavigate = (to) => () => {
    toggle()
    navigate(to)
  }

  return (
    <Menu
      right
      {...props}
      isOpen={isOpen}
      styles={sidebarStyles}
      customBurgerIcon={<GiHamburgerMenu role="button" onClick={toggle} />}
      onStateChange={onStateChange}
    >
      <Box onClick={closeAndNavigate('/')}>
        <span>Home</span>
      </Box>
      <Box onClick={closeAndNavigate('/laporan-pengaduan/create')}>
        Buat Laporan
      </Box>
      <Box onClick={closeAndNavigate('/about')}>Tentang</Box>
      {/* <Box onClick={closeAndNavigate('/disclaimer')}>Disclaimer</Box> */}
      <Box onClick={closeAndNavigate('/mechanism')}>Mekanisme</Box>
      <Box onClick={closeAndNavigate('/definition')}>Definition</Box>
      <Box
        onClick={() => {
          if (userToken) logout()
          toggle()
          navigate('/login')
        }}
      >
        {userToken ? 'Logout' : 'Login'}
      </Box>
    </Menu>
  )
}
